var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { SearchCellGetUsersDocument } from './query.gql';
export function useUsers(userIds) {
    const _a = useQuery(SearchCellGetUsersDocument, {
        fetchPolicy: 'cache-only', // Cache should already be primed with the data
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const users = ((data === null || data === void 0 ? void 0 : data.users) || []).filter(({ id }) => userIds === null || userIds === void 0 ? void 0 : userIds.includes(id));
    const normalizedUsers = users.map((user) => {
        var _a;
        return ({
            id: user.id,
            name: (_a = user.name) !== null && _a !== void 0 ? _a : '',
        });
    });
    return Object.assign({ users: normalizedUsers }, rest);
}
